export enum FilterOperator {
  EQUAL = 'EQ',
  NOT_EQUAL = 'NE',
  GT = 'GT',
  GTE = 'GE',
  LT = 'LT',
  LTE = 'LE',
  CONTAINS = 'CS',
  NOT_CONTAINS = 'CN',
  IN = 'IN',
}
